import { Injectable } from '@angular/core';
import { ResourceIdentifier } from 'jsonapi-transformers';
import { Observable, forkJoin } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

import { RoleId } from '®shared/permissions/roles';
import { MetaData } from '®shared/tarl-v3-jsonapi';
import { RoleRecord, UserService } from '®shared/user';

import { ReadingListService } from '../models';

import { ListOwnerAndIsPublisher } from './owner-with-list-publisher-flag';

@Injectable()
export class ReadingListMetadataService {
  constructor(
    private userService: UserService,
    private readingListService: ReadingListService,
  ) {}

  assignListOwnersAndPublishers(
    listId: string,
    ownersWithPublisherFlags: ListOwnerAndIsPublisher[],
  ): Observable<MetaData<ResourceIdentifier[]>> {
    const owners = ownersWithPublisherFlags.map(({ owner }) => owner);

    const publishers = ownersWithPublisherFlags.reduce(
      (acc, { isPublisher, owner }) => (isPublisher ? [...acc, owner] : acc),
      [],
    );

    const roleRecord = new RoleRecord();
    roleRecord.id = RoleId.LIST_PUBLISHER;

    const listDetails = {
      type: 'lists',
      id: listId,
    };

    if (publishers.length === 0) {
      return this.readingListService.updateListOwners(listId, owners);
    }

    return this.readingListService.updateListOwners(listId, owners).pipe(
      switchMap(metadata => {
        const assignPublishers = publishers.map(publisher =>
          this.userService.assignRoleToUser(roleRecord, publisher, listDetails),
        );
        return forkJoin(assignPublishers).pipe(map(() => metadata));
      }),
    );
  }
}
